// SiteUP V2 (F1.2e) — tradução de classe de ícone LEGADA salva no banco.
//
// Três catálogos deixam o usuário escolher um ícone e gravam a CLASSE COMPLETA:
// `custom_attribute_definitions.icon`, `dashboard_apps.icon` e os ícones de
// atalho em `users.ui_settings` (conversations_quick_filters*). As fatias
// F1.2b/c migraram o app de Lucide para Remix, mas o que já estava gravado
// continua em `i-lucide-*`.
//
// A escolha desta fatia foi NÃO migrar dado: nenhum UPDATE, nenhuma migração.
// Os catálogos passam a oferecer Remix (todo ícone novo já nasce Remix) e a
// classe legada é traduzida AQUI, no momento de renderizar. É reversível, não
// tem janela de inconsistência e, se o mapa errar em algum caso, o pior efeito
// é um ícone diferente — nunca um ícone perdido.
//
// Por que o mapa fica escrito por extenso: o Tailwind/JIT
// (@egoist/tailwindcss-icons) só gera CSS de classe literal no código-fonte;
// classe montada em runtime passa no build e some na tela. Este arquivo está
// sob `dashboard/helper/**/*.js`, um dos globs de `content` do
// tailwind.config.js — é isso que garante o CSS dos ícones Remix dos três
// catálogos. As chaves `i-lucide-*` também são literais de propósito: o CSS
// legado continua sendo emitido e serve de rede de segurança caso algum ponto
// de leitura escape do tradutor.
//
// Derivado de `~/.agents/skills/siteup-x-design-system/references/
// icon-subs-f12b.json` (as 358 substituições validadas da F1.2b), reduzido às
// 74 classes que os catálogos ofereciam, mais 2 legados que não estão mais no
// código mas continuam salvos no banco de clientes:
//   - i-lucide-square-kanban: default dos presets Kanban antes da F1.2b
//   - i-lucide-layers: saiu do FILTER_ICON_CHOICES (virou layers-2) antes de
//     a F1.2b rodar, então não entrou nas 358; alinhado com layers-2
export const LEGACY_LUCIDE_TO_REMIX = {
  'i-lucide-archive': 'i-ri-archive-line',
  'i-lucide-badge-check': 'i-ri-verified-badge-line',
  'i-lucide-banknote': 'i-ri-cash-line',
  'i-lucide-bar-chart-3': 'i-ri-bar-chart-grouped-line',
  'i-lucide-bell': 'i-ri-bell-line',
  'i-lucide-blocks': 'i-ri-apps-2-line',
  'i-lucide-bolt': 'i-ri-flashlight-line',
  'i-lucide-bookmark': 'i-ri-bookmark-line',
  'i-lucide-bot': 'i-ri-robot-line',
  'i-lucide-briefcase': 'i-ri-briefcase-line',
  'i-lucide-building-2': 'i-ri-building-2-line',
  'i-lucide-calendar': 'i-ri-calendar-line',
  'i-lucide-calendar-days': 'i-ri-calendar-2-line',
  'i-lucide-chart-spline': 'i-ri-line-chart-line',
  'i-lucide-circle-check': 'i-ri-checkbox-circle-line',
  'i-lucide-circle-dot': 'i-ri-radio-button-line',
  'i-lucide-clock': 'i-ri-time-line',
  'i-lucide-clock-3': 'i-ri-time-line',
  'i-lucide-cog': 'i-ri-settings-3-line',
  'i-lucide-credit-card': 'i-ri-bank-card-line',
  'i-lucide-dollar-sign': 'i-ri-money-dollar-box-line',
  'i-lucide-file-text': 'i-ri-file-text-line',
  'i-lucide-filter': 'i-ri-filter-line',
  'i-lucide-flag': 'i-ri-flag-line',
  'i-lucide-flame': 'i-ri-fire-line',
  'i-lucide-folder': 'i-ri-folder-line',
  'i-lucide-folder-open': 'i-ri-folder-open-line',
  'i-lucide-globe': 'i-ri-globe-line',
  'i-lucide-hash': 'i-ri-hashtag',
  'i-lucide-heart': 'i-ri-heart-line',
  'i-lucide-heart-handshake': 'i-ri-hand-heart-line',
  'i-lucide-home': 'i-ri-home-line',
  'i-lucide-inbox': 'i-ri-inbox-line',
  'i-lucide-info': 'i-ri-information-line',
  'i-lucide-laptop': 'i-ri-computer-line',
  'i-lucide-layers': 'i-ri-stack-line',
  'i-lucide-layers-2': 'i-ri-stack-line',
  'i-lucide-layout-grid': 'i-ri-layout-grid-line',
  'i-lucide-library-big': 'i-ri-book-shelf-line',
  'i-lucide-line-chart': 'i-ri-line-chart-line',
  'i-lucide-link': 'i-ri-link',
  'i-lucide-mail': 'i-ri-mail-line',
  'i-lucide-map-pin': 'i-ri-map-pin-line',
  'i-lucide-megaphone': 'i-ri-megaphone-line',
  'i-lucide-message-circle': 'i-ri-chat-1-line',
  'i-lucide-message-square-quote': 'i-ri-chat-quote-line',
  'i-lucide-messages-square': 'i-ri-chat-3-line',
  'i-lucide-package': 'i-ri-box-1-line',
  'i-lucide-panels-left-bottom': 'i-ri-layout-bottom-2-line',
  'i-lucide-phone': 'i-ri-phone-line',
  'i-lucide-pin': 'i-ri-pushpin-line',
  'i-lucide-puzzle': 'i-ri-puzzle-line',
  'i-lucide-rocket': 'i-ri-rocket-line',
  'i-lucide-search': 'i-ri-search-line',
  'i-lucide-settings': 'i-ri-settings-line',
  'i-lucide-shield': 'i-ri-shield-line',
  'i-lucide-shield-check': 'i-ri-shield-check-line',
  'i-lucide-shopping-cart': 'i-ri-shopping-cart-line',
  'i-lucide-sliders-horizontal': 'i-ri-equalizer-line',
  'i-lucide-smartphone': 'i-ri-smartphone-line',
  'i-lucide-sparkles': 'i-ri-sparkling-line',
  'i-lucide-square-kanban': 'i-ri-kanban-view',
  'i-lucide-star': 'i-ri-star-line',
  'i-lucide-tag': 'i-ri-price-tag-line',
  'i-lucide-tags': 'i-ri-price-tag-2-line',
  'i-lucide-target': 'i-ri-target-line',
  'i-lucide-thumbs-up': 'i-ri-thumb-up-line',
  'i-lucide-triangle-alert': 'i-ri-alert-line',
  'i-lucide-trophy': 'i-ri-trophy-line',
  'i-lucide-truck': 'i-ri-truck-line',
  'i-lucide-user': 'i-ri-user-line',
  'i-lucide-user-cog': 'i-ri-user-settings-line',
  'i-lucide-users': 'i-ri-group-line',
  'i-lucide-wand-sparkles': 'i-ri-magic-line',
  'i-lucide-workflow': 'i-ri-flow-chart',
  'i-lucide-zap': 'i-ri-flashlight-line',
};

/**
 * Traduz uma classe de ícone salva antes da migração para Remix.
 *
 * Valor já Remix (`i-ri-*`), classe fora do mapa (inclusive os `i-lucide-*`
 * que a F1.2b decidiu manter em Lucide), string vazia, `null`/`undefined` ou
 * qualquer coisa que não seja string saem EXATAMENTE como entraram.
 *
 * @param {string|any} icon classe de ícone lida do banco / ui_settings
 * @returns {string|any} classe a renderizar
 */
export const resolveSavedIconClass = icon => {
  if (typeof icon !== 'string' || !icon) return icon;
  return LEGACY_LUCIDE_TO_REMIX[icon] ?? icon;
};
